import { all, fork } from 'redux-saga/effects';

import watchLicenseChildrenSaga from '../modules/LicenseChildren/store/sagas';
import { watchLicensesSaga } from '../modules/Licenses/store/sagas';
import watchLicenseSaga from '../modules/License/store/sagas';

import watchRimmSaga from '../modules/rimm/store/sagas';
import watchLicenseTypeSaga from './licenseType/sagas';
import { watchConfigsSaga } from './configs/sagas';
import { watchAuditSaga } from './audit/sagas';

export default function* rootSaga() {
  yield all([
    fork(watchLicensesSaga),
    fork(watchAuditSaga),
    fork(watchConfigsSaga),
    fork(watchLicenseSaga),
    fork(watchLicenseTypeSaga),
    fork(watchRimmSaga),
    fork(watchLicenseChildrenSaga),
  ]);
}
